module.exports = __webpack_public_path__ + "static/media/search_web_3.a7bed116.png";